import {
    ADD_ROLE,
    GET_ROLE,
    ALL_ROLE,
    EDIT_ROLE,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    data: null
  }
  
  const addRole = (state = initialState, action) => {
    switch (action.type) {
      case ADD_ROLE:
      case GET_ROLE:
        state = {
          ...state,
          loading: true,
        }
        break
        case ALL_ROLE:
          case EDIT_ROLE:
            state = {
              ...state,
              loading: false,
              data:action.payload.data
            }
            break
        default:
        break
    }
    return state
  }

 

  export  default addRole
  